// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1D99D","noInteraction":"EventWrapper_noInteraction__1xGkf","pointerPassthrough":"EventWrapper_pointerPassthrough__2kmNQ"};